module.exports = __webpack_public_path__ + "static/media/connector_icon_glue.37b6d93f.svg";